<template>
  <div class="container" >
    <img class="logo" src="/static/img/KovoHome_text_white.svg" alt="Logo" />
    <div>
      <div class="loginContainer cardBackground">
        <h1>Sales Registration</h1>

        <div class="emailContainer">
          <input ref="firstname" class="loginInput" :class="{ invalidInput: firstnameError, invalidField: submitted && !firstname }" type="text" v-model="firstname" placeholder="First Name"/>
          <div v-if="firstnameError" class="errorText">{{ firstnameError }}</div>
        </div>
        <div class="emailContainer">
          <input ref="lastname" class="loginInput" :class="{ invalidInput: lastnameError, invalidField: submitted && !lastname }" type="text" v-model="lastname" placeholder="Last Name"/>
          <div v-if="lastnameError" class="errorText">{{ lastnameError }}</div>
        </div>

        <div class="emailContainer">
          <input
              ref="username"
              class="loginInput"
              type="text"
              v-model="username"
              :class="{ invalidInput: usernameError, invalidField: submitted && !username }"
              placeholder="Username"
          />
          <div v-if="usernameError" class="errorText">{{ usernameError }}</div>
        </div>

        <div class="emailContainer">
          <input
              ref="phone"
              class="loginInput"
              type="text"
              v-model="phone"
              :class="{ invalidInput: phoneError, invalidField: submitted && !phone }"
              placeholder="(XXX) XXX-XXXX"
          />
          <div v-if="phoneError" class="errorText">{{ phoneError }}</div>
        </div>

        <div class="emailContainer">
          <input ref="address1" :class="{ invalidField: submitted && !address1 }" class="loginInput" type="text" v-model="address1" placeholder="Address">
          <div v-if="address1Error" class="errorText">{{ address1Error }}</div>
        </div>
        <div class="emailContainer">
          <input class="loginInput" type="text" v-model="address2" placeholder="Address 2">
        </div>

        <div class="emailContainer">
          <input ref="city" :class="{ invalidInput: cityError, invalidField: submitted && !city }" class="loginInput" type="text" v-model="city" placeholder="City">
          <div v-if="cityError" class="errorText">{{ cityError }}</div>
        </div>

        <div class= "formRow">
          <div class="formField">
            <el-select
                ref="state"
                v-model="state"
                placeholder="Select a state"
                :class="{ invalidInput: stateError, invalidField: submitted && !state }"
                class="loginInput customSelect custom-select-height"
                style="padding:0 15px;"
                popper-class="customSelectDropdown"
                :value="state"
            >
              <el-option
                  v-for="s in usStates"
                  :key="s.abbr"
                  :value="s.abbr"
              >
                {{ s.name }}
              </el-option>
            </el-select>
            <div v-if="stateError" class="errorText">{{ stateError }}</div>
          </div>
          <div class="formField">
            <input
                ref="zip"
                class="loginInput"
                type="text"
                v-model="zip"
                :class="{ invalidInput: zipError, invalidField: submitted && !zip }"
                placeholder="Zip"
            />
            <div v-if="zipError" class="errorText">{{ zipError }}</div>
          </div>
        </div>

        <div class="emailContainer">
          <input
              ref="email"
              class="loginInput"
              type="text"
              v-model="email"
              :class="{ invalidInput: emailError, invalidField: submitted && !email }"
              placeholder="Email"
          />
          <div v-if="emailError" class="errorText">{{ emailError }}</div>
        </div>

        <div class="passwordContainer">
          <input
              class="loginInput"
              ref="password"
              :type="viewPassword ? 'text' : 'password'"
              v-model="password"
              :class="{ invalidInput: passwordError,  invalidField: submitted && !password }"
              placeholder="Password"
          />
          <svg
              @click="togglePasswordVisibility"
              class="viewPasswordIcon"
              :class="viewPassword ? 'colorSwap' : ''"
          >
            <use href="/static/icons/Eye.svg#Eye"/>
          </svg>
          <div v-if="passwordError" class="errorText">{{ passwordError }}</div>
        </div>

        <div class="emailContainer">
          <input
              ref="confirmPassword"
              class="loginInput"
              :type="viewPasswordConf ? 'text' : 'password'"
              v-model="confirmPassword"
              :class="{ invalidInput: confirmPasswordError, invalidField: submitted && !confirmPassword }"
              placeholder="Confirm Password"
          />
          <svg
              @click="togglePasswordVisibilityConf"
              class="viewPasswordIcon"
              :class="viewPasswordConf ? 'colorSwap' : ''"
          >
            <use href="/static/icons/Eye.svg#Eye"/>
          </svg>
          <div v-if="confirmPasswordError" class="errorText">{{ confirmPasswordError }}</div>
        </div>

        <div class="emailContainer">
          <input
              class="loginInput"
              type="text"
              v-model="agentId"
              :class="{ invalidInput: emailError }"
              placeholder="Agent ID"
          />
          <div v-if="agentIdError" class="errorText">{{ emailError }}</div>
        </div>



        <div class="emailContainer paymentMethod">
          <h3>Payment Method</h3>
          <el-radio-group class="large-radio" v-model="selectedPaymentMethod">
            <el-radio label="card">Credit Card</el-radio>
            <el-radio label="klarna">Klarna (Apply for Credit)</el-radio>
          </el-radio-group>
        </div>

        <div v-if="selectedPaymentMethod === 'card'" class="emailContainer">

          <div class="passwordContainer">
            <h3>Selected Plan</h3>
            <el-select
                v-model="selectedPlan"
                popper-append-to-body
                placeholder="Select a Plan"
                class="loginInput customSelect"
                style="padding:0 15px;"
                popper-class="customSelectDropdown"
            >
              <el-option
                  v-for="plan in subscriptionPlans"
                  :key="plan.name"
                  :label="`${plan.descriptions[0]}, ${plan.descriptions[1]} `"
                  :value="plan.name"
              />
            </el-select>
          </div>

          <h3>Card Information</h3>

          <div id="card-number-element" class="loginInput stripe-input"></div>
          <div class="stripe-inline-row">
            <div id="card-expiry-element" class="loginInput stripe-input half-width"></div>
            <div id="card-cvc-element" class="loginInput stripe-input half-width"></div>
          </div>

          <div class="emailContainer terms-link">
            <h4> By registering you agree to these <a href="#" @click="dialogVisible = true"> terms and conditions </a></h4>
          </div>
          <div>
            <el-button
                class="specialButton"
                type="primary"
                :loading="isLoading"
                :disabled="isLoading"
                @click="register(false)"
            >
              Register
            </el-button>
          </div>

        </div>

        <div v-if="selectedPaymentMethod === 'klarna'" class="emailContainer">

          <div class="passwordContainer">

            <h3>{{ currentPlan?.full_description }}</h3>

          </div>

          <el-button type="primary" @click="register(true)">Start Klarna Credit Application</el-button>
        </div>


      </div>
    </div>
    <MessageModal :message="appMessage.text" :type="appMessage.type" ref="messageModal" />

    <el-dialog
        title="Terms and Conditions"
        :visible.sync="dialogVisible"
        width="90%"
        @close="onClose"
    >
      <terms-and-conditions></terms-and-conditions>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onConfirm">
          Agree
        </el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
/* global Stripe */
import {useLoginStore} from "@/stores/loginStore";
import CommonAPIService from "@/servicehandlers/CommonHandler";
import MessageModal from "@/components/MessageModal.vue";
import TermsAndConditions from "@/components/TermsAndConditions.vue";

const commonService = new CommonAPIService()
export default {
  name: 'RegisterPage',
  components: {
    MessageModal,
    TermsAndConditions,
  },
  data(){
    return {
      isLoading: false,
      dialogVisible: false,
      selectedPaymentMethod: 'card',
      appMessage: {
        text: '',
        type: 'error',
      },
      error: {
        text: '',
        title: '',
      },
      firstInvalidField: null,
      submitted: false,
      firstname:'',
      lastname:'',
      username: '',
      usernameError: '',
      address1:'',
      address2:'',
      city:'',
      state:'UT',
      zip:'',
      phone:'',
      email: '',
      password: '',
      agentId: '',
      viewPassword: false,
      viewPasswordConf: false,
      confirmPassword: '',
      passwordError: '',
      agentIdError: '',
      confirmPasswordError: '',
      emailError: '',
      zipError: '',
      phoneError: '',
      firstnameError: '',
      lastnameError: '',
      address1Error: '',
      cityError: '',
      stateError: '',
      subscriptionPlans: [],
      klarnaSubscriptionPlans: [],
      selectedPlan: 'aivghp2yearplan',
      selectedKlarnaPlan: 'aivghp2yearplan',
      usStates: [
        { abbr: 'AL', name: 'Alabama' },
        { abbr: 'AK', name: 'Alaska' },
        { abbr: 'AZ', name: 'Arizona' },
        { abbr: 'AR', name: 'Arkansas' },
        { abbr: 'CA', name: 'California' },
        { abbr: 'CO', name: 'Colorado' },
        { abbr: 'CT', name: 'Connecticut' },
        { abbr: 'DE', name: 'Delaware' },
        { abbr: 'FL', name: 'Florida' },
        { abbr: 'GA', name: 'Georgia' },
        { abbr: 'HI', name: 'Hawaii' },
        { abbr: 'ID', name: 'Idaho' },
        { abbr: 'IL', name: 'Illinois' },
        { abbr: 'IN', name: 'Indiana' },
        { abbr: 'IA', name: 'Iowa' },
        { abbr: 'KS', name: 'Kansas' },
        { abbr: 'KY', name: 'Kentucky' },
        { abbr: 'LA', name: 'Louisiana' },
        { abbr: 'ME', name: 'Maine' },
        { abbr: 'MD', name: 'Maryland' },
        { abbr: 'MA', name: 'Massachusetts' },
        { abbr: 'MI', name: 'Michigan' },
        { abbr: 'MN', name: 'Minnesota' },
        { abbr: 'MS', name: 'Mississippi' },
        { abbr: 'MO', name: 'Missouri' },
        { abbr: 'MT', name: 'Montana' },
        { abbr: 'NE', name: 'Nebraska' },
        { abbr: 'NV', name: 'Nevada' },
        { abbr: 'NH', name: 'New Hampshire' },
        { abbr: 'NJ', name: 'New Jersey' },
        { abbr: 'NM', name: 'New Mexico' },
        { abbr: 'NY', name: 'New York' },
        { abbr: 'NC', name: 'North Carolina' },
        { abbr: 'ND', name: 'North Dakota' },
        { abbr: 'OH', name: 'Ohio' },
        { abbr: 'OK', name: 'Oklahoma' },
        { abbr: 'OR', name: 'Oregon' },
        { abbr: 'PA', name: 'Pennsylvania' },
        { abbr: 'RI', name: 'Rhode Island' },
        { abbr: 'SC', name: 'South Carolina' },
        { abbr: 'SD', name: 'South Dakota' },
        { abbr: 'TN', name: 'Tennessee' },
        { abbr: 'TX', name: 'Texas' },
        { abbr: 'UT', name: 'Utah' },
        { abbr: 'VT', name: 'Vermont' },
        { abbr: 'VA', name: 'Virginia' },
        { abbr: 'WA', name: 'Washington' },
        { abbr: 'WV', name: 'West Virginia' },
        { abbr: 'WI', name: 'Wisconsin' },
        { abbr: 'WY', name: 'Wyoming' }
      ]
    }
  },
  computed: {
    currentPlan() {
      return this.klarnaSubscriptionPlans.find(p => p.name === this.selectedKlarnaPlan );
    },
    isEmailValid() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(this.email);
    },
    isZipValid() {
      const zipRegex = /^\d{5}(-\d{4})?$/;
      return zipRegex.test(this.zip);
    },
    isPhoneValid() {
      const digits = this.getNormalizedPhone();
      return /^\d{10}$/.test(digits);
    },
    isUsernameValid() {
      // only letters, numbers and underscores
      const usernameRegex = /^[a-zA-Z0-9_]+$/;
      return usernameRegex.test(this.username);
    },
    isPasswordComplex() {
      // min 8 chars, at least 1 lowercase, 1 uppercase, 1 digit, 1 special
      const rx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
      return rx.test(this.password);
    },
    doPasswordsMatch() {
      return this.password === this.confirmPassword;
    },
  },
  watch: {

    selectedPaymentMethod(value){
      if (value === 'klarna') {
        this.selectedKlarnaPlan = 'aivghp2yearplan';

        // 👇 Unmount stripe elements when leaving card
        if (this.cardNumber) this.cardNumber.unmount();
        if (this.cardExpiry) this.cardExpiry.unmount();
        if (this.cardCvc) this.cardCvc.unmount();
      }

      if (value === 'card') {
        this.$nextTick(() => {
          this.initStripe(); // 👈 Re-initialize and mount again
        });
      }

    },
    email(value) {
      if (value === '') {
        this.emailError = '';
      } else if (!this.isEmailValid) {
        this.emailError = 'Please enter a valid email address';
      } else {
        this.emailError = '';
      }
    },
    zip(value) {
      if (value === '') {
        this.zipError = '';
      } else if (!this.isZipValid) {
        this.zipError = 'Enter a valid ZIP (e.g. 84003 or 84003-1234)';
      } else {
        this.zipError = '';
      }
    },
    phone(newVal) {
      const formatted = this.formatPhoneInput(newVal);
      if (formatted !== newVal) {
        this.phone = formatted;
      }
      if (!this.isPhoneValid && this.phone.replace(/\D/g, '').length > 0) {
        this.phoneError = 'Enter a valid 10-digit phone number';
      } else {
        this.phoneError = '';
      }
    },
    username(value) {
      if (value === '') {
        this.usernameError = '';
      } else if (!this.isUsernameValid) {
        this.usernameError = 'Username can only contain letters, numbers, and underscores';
      } else {
        this.usernameError = '';
      }
    },
    password(val) {
      if (val === '') {
        this.passwordError = '';
      } else if (!this.isPasswordComplex) {
        this.passwordError = 'Password must be ≥8 chars and include upper, lower, digit, special';
      } else {
        this.passwordError = '';
      }
      // re-check match when password changes
      if (this.confirmPassword && !this.doPasswordsMatch) {
        this.confirmPasswordError = 'Passwords do not match';
      } else {
        this.confirmPasswordError = '';
      }
    },
    confirmPassword(val) {
      if (val === '') {
        this.confirmPasswordError = '';
      } else if (!this.doPasswordsMatch) {
        this.confirmPasswordError = 'Passwords do not match';
      } else {
        this.confirmPasswordError = '';
      }
    },
  },
  mounted() {
    //console.clear()
    //if (this.store.loggedIn){
      //this.goToHome()
    //}
    useLoginStore().logOut()
    if (!window.Stripe) {
      const script = document.createElement('script')
      script.src = 'https://js.stripe.com/v3/'
      script.onload = this.initStripe
      document.head.appendChild(script)
    } else {
      this.initStripe()
    }

    this.getSubscriptionOptions();
    this.getKlarnaSubscriptionOptions();

  },
  methods: {

    onConfirm() {
      // your confirm logic here…
      this.dialogVisible = false
    },

    onClose() {
      // optional cleanup when dialog closes
      console.log('Dialog closed')
    },

    async initStripe() {
      this.stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY)
      this.elements = this.stripe.elements()

      const style = {
        base: {
          fontSize: '30px',

          color: '#FFF',
          '::placeholder': {
            color: '#555'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      }

      this.cardNumber = this.elements.create('cardNumber', { style })
      this.cardExpiry = this.elements.create('cardExpiry', { style })
      this.cardCvc = this.elements.create('cardCvc', { style })

      this.cardNumber.mount('#card-number-element')
      this.cardExpiry.mount('#card-expiry-element')
      this.cardCvc.mount('#card-cvc-element')
    },

    getSubscriptionOptions(){
      const url = `${process.env.VUE_APP_API_URL}/api/payments/phased_subscriptions`;
      fetch(url)
          .then(res => res.json())
          .then(data => {
            this.subscriptionPlans = data;
            console.log(JSON.stringify(data, null, 2));
          });
    },
    getKlarnaSubscriptionOptions(){
      const url = `${process.env.VUE_APP_API_URL}/api/payments/klarna_subscriptions`;
      fetch(url)
          .then(res => res.json())
          .then(data => {
            this.klarnaSubscriptionPlans = data;
            console.log(JSON.stringify(data, null, 2));
          });
    },

    getNormalizedPhone() {
      return this.phone.replace(/\D/g, ''); // strip non-digits
    },

    formatPhoneInput(raw) {
      const digits = raw.replace(/\D/g, '').substring(0, 10);
      const match = digits.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
      if (!match) return raw;
      let formatted = '';
      if (match[1]) formatted += `(${match[1]}`;
      if (match[1] && match[1].length === 3) formatted += ') ';
      if (match[2]) formatted += match[2];
      if (match[2] && match[2].length === 3) formatted += '-';
      if (match[3]) formatted += match[3];
      return formatted;
    },

    togglePasswordVisibility(){
      this.viewPassword = !this.viewPassword
    },
    togglePasswordVisibilityConf(){
      this.viewPasswordConf = !this.viewPasswordConf
    },

    async startKlarnaPayment() {

      const priceMap = {
        aivghp2yearplan: 'price_ABC123',   // replace with real price IDs
        aivghpmonthlyplan: 'price_DEF456'
      };

      try {
        console.log('process.env.VUE_APP_API_URL', process.env.VUE_APP_API_URL);
        const response = await fetch(`${process.env.VUE_APP_API_URL}/api/payments/klarna-session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: this.email,
            priceId: priceMap[this.selectedKlarnaPlan],
            quantity: 1
          })
        });

        const result = await response.json();
        if (result.redirect_url) {
          window.location.href = result.redirect_url;
        } else {
          throw new Error('No redirect URL returned');
        }
      } catch (error) {
        console.error(error);
        this.appMessage.text = 'Failed to start Klarna payment';
        this.appMessage.type = 'error';
        this.$refs.messageModal.open(8000);
      }
    },

    async setError(field, message){

      this.appMessage.text = message;
      this.appMessage.type = 'error'
      this.$refs.messageModal.open(8000)

    },

     async checkParams() {
      // reset previous field error tag
      this.firstInvalidField = null;

      // simple map of field → human label
      const required = {
        firstname: 'First name',
        lastname: 'Last name',
        username: 'Username',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        email: 'Email',
        phone: 'Phone',
        address1: 'Address',
        city: 'City',
        state: 'State',
        zip: 'Zip',
        selectedPlan: 'Plan',
      };

      let ok = true;

      // clear any old error text
      Object.keys(required).forEach(f => {
        const errProp = f + 'Error';
        if (this[errProp] !== undefined) this[errProp] = '';
      });

      for (const field of Object.keys(required)) {
        const val = this[field];
        if (!val || (field === 'selectedPlan' && !this.selectedPlan)) {
          ok = false;
          // set a generic “required” message
          const errProp = field + 'Error';
          if (this[errProp] !== undefined)
            this[errProp] = `${required[field]} is required`;

          // remember the very first one
          if (!this.firstInvalidField) {
            this.firstInvalidField = field;
          }
        }
      }

      // extra format checks
      if (ok && !this.isEmailValid) {
        this.emailError = 'Please enter a valid email address';
        if (!this.firstInvalidField) this.firstInvalidField = 'email';
        ok = false;
      }
      if (ok && !this.isZipValid) {
        this.zipError = 'Enter a valid ZIP (e.g. 84003 or 84003-1234)';
        if (!this.firstInvalidField) this.firstInvalidField = 'zip';
        ok = false;
      }
      if (ok && !this.isPhoneValid) {
        this.phoneError = 'Enter a valid 10-digit phone number';
        if (!this.firstInvalidField) this.firstInvalidField = 'phone';
        ok = false;
      }
      if (ok && !this.isUsernameValid) {
        this.usernameError = 'Username can only contain letters, numbers, underscores';
        if (!this.firstInvalidField) this.firstInvalidField = 'username';
        ok = false;
      }
      if (ok && !this.isPasswordComplex) {
        this.passwordError = 'Password must be ≥8 chars and include upper, lower, digit, special';
        if (!this.firstInvalidField) this.firstInvalidField = 'password';
        ok = false;
      }
      if (ok && !this.doPasswordsMatch) {
        this.confirmPasswordError = 'Passwords do not match';
        if (!this.firstInvalidField) this.firstInvalidField = 'confirmPassword';
        ok = false;
      }

      if (!ok && this.firstInvalidField) {
        // wait until DOM has applied error classes
        this.$nextTick(() => {
          const fld = this.$refs[this.firstInvalidField];
          if (fld && fld.$el) {
            // Element UI component
            fld.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            fld.focus();
          } else if (fld && fld.scrollIntoView) {
            fld.scrollIntoView({ behavior: 'smooth', block: 'center' });
            fld.focus();
          }
        });
      }

      return ok;
    },

    async checkUser(){

      try {

        const res = await fetch(`${process.env.VUE_APP_API_URL}/api/auth/checkuser`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            username: this.username
          })
        })

        if (!res.ok) {
          const errorText = await res.text();

          this.isLoading = false;
          this.isSignUpDisabled = false;
          throw new Error(errorText || 'User check failed');
        }

        const data = res.json()
        if (data.error) throw new Error(data.error)

      } catch (err) {
        this.errorSignupMessages = err.message || 'Subscription failed';
        this.errorSignup = true;
        this.isLoading = false;
        this.isSignUpDisabled = false;
        return false;
      }

      return true;
    },

    getParameters(){

      return {
        firstname: this.firstname,
        lastname: this.lastname,
        email: this.email,
        address1: this.address1,
        address2: this.address2,
        phone: this.getNormalizedPhone(),
        city: this.city,
        state: this.state,
        zip: this.zip,
        username: this.username,
        password: this.password,
        agent_id: this.agentId,
        planName: this.selectedPlan,
      };

    },

    async register( startKlarna  = false) {
      //this.resetErrors()
      this.submitted = true;
      if (!await this.checkParams()) {
        return;
      }

      this.isLoading = true
      this.isSignUpDisabled = true

      const userCheck = await this.checkUser();
      if (! userCheck ) {
        return;
      }

      const parameters = this.getParameters();

      parameters.startKlarna = startKlarna;

      if (! startKlarna) {
        const {paymentMethod, error} = await this.stripe.createPaymentMethod({
          type: 'card',
          card: this.cardNumber,
          billing_details: {
            name: `${this.firstname} ${this.lastname}`,
            email: this.email
          }
        })

        if (error) {
          this.errorSignupMessages = error.message;
          this.errorSignup = true;
          this.isLoading = false;
          this.isSignUpDisabled = false;
          return;
        }

        parameters.paymentMethodId = paymentMethod?.id || undefined;
      }

      try {


        commonService
            .register(parameters)
            .then((response) => {
              console.log('Register response:', response)
              if (response && response.success) {
                this.isLoading = false
                this.isSignUpDisabled = false

                console.log(JSON.stringify(response, null, 2));
                console.log('startKlarna', startKlarna);
                console.log('data', JSON.stringify(response.data, null, 2));
                console.log('klarna_redirect_url', JSON.stringify(response.data.klarna_redirect_url, null, 2));

                if (startKlarna && response.data &&  response.data.klarna_redirect_url ) {
                  window.location.href = response.data.klarna_redirect_url;
                }
                else {
                  this.goToFinishRegistration(response.data);
                }

              } else {

                console.log('ERRORRO', JSON.stringify(response, null, 2));
                const message = response && response.errorBody && response.errorBody.details
                    ? `${response.errorBody.error}: ${response.errorBody.details}`
                    : response.errorBody?.error || 'Unexpected registration error';

                this.appMessage.text = message;
                this.appMessage.type = 'error'
                this.$refs.messageModal.open(8000)
              }
            })
            .catch((e) => {
              console.log('Unexpected catch:', JSON.stringify(e, null, 2))

              // Pull the JSON error body out of error.response.data
              const data = e.response && e.response.data;
              const message = data && data.error && data.details
                  ? `${data.error}: ${data.details}`
                  : 'Unexpected registration error';

              this.appMessage.text = message;
              this.appMessage.type = 'error'
              this.$refs.messageModal.open(8000)
            });


      }

      catch (err) {
        this.errorSignupMessages = err.message || 'Subscription failed';
        this.errorSignup = true;
        this.isLoading = false;
        this.isSignUpDisabled = false;
        return;
      }

    },

    async goToHome(){
      this.$router.push({
        name: 'dashboard'
      })
    },
    async goToLogin(){
      this.$router.push({
        name: 'login'
      })
    },
    async goToFinishRegistration( response ){
      this.$router.push({
        name: 'finishregistration',
        params: { regInfo: response }
      })
    },

  },
}
</script>

<style >

/* Make el-select dropdown and inputs dark */
.customSelectx .el-input__inner {
  background-color: #1e1e1e !important; /* or match your dark bg */
  color: var(--text-primary) !important;
  border: 1px solid #444; /* Optional: to match other dark elements */
}

/* Dropdown popup */
.customSelectDropdown {
  background-color: #2a2a2a !important; /* dark background */
  color: #f0f0f0 !important;
}

/* Individual dropdown items */
.customSelectDropdown .el-select-dropdown__item {
  background-color: transparent !important;
  color: #ddd !important;
}

/* Hovered item */
.customSelectDropdown .el-select-dropdown__item:hover {
  background-color: #444 !important;
  color: #fff !important;
}

/* Selected item */
.customSelectDropdown .el-select-dropdown__item.selected {
  background-color: #333 !important;
  font-weight: bold;
  color: #00bcd4 !important;
}

.colorSwap{
  color: var(--text-primary) !important;
  background-color: transparent !important;
}
.rightCaret{
  color: white;
  width: 12px;
  height: 21px;
}
.otherWrapper{
  width: 100%;
  display: flex;
  align-items: center;
  gap: 15px;
}
.logo{
  width: 80%;
  max-height:120px;
  margin: 0 auto;
  padding: 20px;
}
.loginContainer{
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  margin: 30px;
  border-radius: 12px;
  padding: 20px;
  max-width: 700px;
}
.emailContainer{
  width: 100%;
}
.emailContainer, .passwordContainer{
  width: 100%;
  position: relative;
}
.viewPasswordIcon{
  position: absolute;
  right: 0;
  top: calc(50% - 10p);
  width: 50px;
  height: 50px;
  color: var(--text-secondary);
  background-color: var(--text-primary);
  padding: 7.5px;
  border-radius: 12px;
}
h3{
  text-align: left;
}
.customSelect .el-input__inner {
  background-color: inherit; /* your dark input bg */
  color: var(--text-primary);
  font-family: inherit;
  font-size: 30px;
  height: 50px;
  border-radius: 10px;
  box-shadow: none;
  transition: border-color 0.2s ease;
  border: none;
  margin:0;
  padding:0;
}

.customSelect .el-input__inner:focus {
  border:none;
  outline: none;
}

.customSelectDropdown .el-select-dropdown__item {
  color: #f0f0f0;
}

.customSelectDropdown .el-select-dropdown__item:hover {
  background-color: inherit;
}

.customSelectDropdown .el-select-dropdown__item.selected {
  font-weight: bold;
  color: #00bcd4;
}

.stripe-input {
  margin-bottom: 12px;
  padding: 10px;
  border: 1px solid #ccd0d5;
  border-radius: 4px;
}

.stripe-inline-row {
  display: flex;
  gap: 12px;
}

.half-width {
  flex: 1;
}

.errorText {
  color: #fa755a;
  font-size: 14px;
  margin-top: 5px;
}

.invalidInput {
  border-color: #fa755a;
}

.terms-link a {
  color:orange;
  text-decoration: none;
}
.terms-link a:hover {
  color: #ff6600;
  text-decoration: none;
}
/* ───────────────────────────────
   Responsive Grid + Field Layout
──────────────────────────────── */
.formRow {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.formField {
  flex: 1;
  min-width: 120px;
  display: flex;
  flex-direction: column;
}


input.loginInput {
  height: 50px;               /* keep your fixed height */
  font-size: clamp(22px, 4vw, 30px) !important;
}


input.loginInput::placeholder {
  font-size: inherit !important;
}

@media (max-width: 450px) {
  input.loginInput {
    font-size: 24px !important;
  }
}

@media (max-width: 400px) {
  input.loginInput {
    font-size: 22px !important;
  }
}

.custom-select-height {
  height: 50px;
  line-height: 50px;
}
/* 1) Anchor the whole select wrapper */
.customSelect {
  position: relative !important;
}

/* 2) Give the input inner room for our bigger, centered arrow */
.customSelect .el-input__inner {
  padding-right: 2.5em !important;  /* leaves ~40px of space on the right */
  position: relative;
  z-index: 1;
}

/* 3) Absolutely position the suffix container that holds the caret */
.customSelect .el-input__suffix-inner {
  position: absolute !important;
  z-index: 0;
  top: 50%                   !important;
  right: -5px                !important; /* tweak this to move it closer/further */
  transform: translateY(-50%)!important;
  width: auto                !important;
  height: auto               !important;
  pointer-events: none       !important; /* so clicks still go “through” */
}

/* 4) Enlarge the actual caret icon inside there */
.customSelect .el-select__caret {
  font-size: 24px    !important;  /* bump size up */
  line-height: 1     !important;
  pointer-events: auto!important; /* restore clickability on the icon */
  color: inherit     !important;  /* match your text color */
}
@media (max-width: 450px) {
  .customSelect .el-input__inner {
    /* less right‐padding so the arrow sits closer to the edge */
    padding-right: 1.5em !important;
  }
}

/* 1) Scale up the whole radio input, with its origin at center */
.large-radio .el-radio__input {
  transform: scale(1.4) !important;
  transform-origin: center center !important;
  margin-right: 0.75rem;  /* keep some space between circle & label */
}

/* 2) Make sure the outer circle wrapper is a positioning context */
.large-radio .el-radio__inner {
  position: relative !important;
}

/* 3) Center the filled dot absolutely inside */
.large-radio .el-radio__inner::after {
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  margin: 0 !important; /* remove any old offsets */
}

/* 4) (Optional) bump up the label text */
.large-radio .el-radio__label {
  font-size: 1.25rem !important;
}
/* 1) Remove the fixed-height & ellipsis */
.customSelectDropdown .el-select-dropdown__item {
  height: auto           !important;  /* let it grow to fit text */
  min-height: 48px       !important;  /* keep a finger-friendly tap area */
  white-space: normal    !important;  /* wrap long labels */
  overflow: visible      !important;  /* don’t hide wrapped text */
  text-overflow: unset   !important;  /* kill the “…” */
}

/* 2) Ensure any inner spans also wrap & don’t overflow */
.customSelectDropdown .el-select-dropdown__item * {
  white-space: normal    !important;
  overflow: visible      !important;
}

/* 3) Constrain the dropdown itself to your viewport */
.customSelectDropdown,
.customSelectDropdown .el-scrollbar__wrap {
  max-width: 95vw        !important;
  width: auto            !important;
  overflow-y: auto       !important;  /* allow vertical scroll if needed */
  z-index: 9999          !important;  /* float above everything */
}
@media (max-width: 600px) {
  /* target the wrapper you added in the template */
  .paymentMethod {
    width: auto !important;            /* don’t fill 100% of parent */
    align-self: flex-start !important; /* pull it to the left edge */
    text-align: left !important;       /* ensure its contents are left-aligned */
    padding-left: 0 !important;        /* remove any extra indent */
  }

  /* make sure the radio buttons themselves stay left-justified */
  .paymentMethod .el-radio-group {
    display: flex !important;
    justify-content: flex-start !important;
    flex-wrap: wrap;                   /* if they do wrap, start new lines at left */
    gap: 0.5rem;                       /* small gap between options */
  }
}
.invalidField {
  box-shadow: 0 0 0 2px rgba(250,117,90,0.7);
  border-color: #fa755a !important;
}
</style>
<style scoped>
/* make the label text bigger */
.large-radio ::v-deep .el-radio__label {
  font-size: 1.2rem;    /* adjust as needed */
  line-height: 1.5;     /* to vertically center with the dot */
}

/* enlarge the outer circle */
.large-radio ::v-deep .el-radio__inner {
  width: 16px;          /* default is ~16px */
  height: 16px;
}

/* enlarge and re-position the inner filled dot when checked */
.large-radio ::v-deep .el-radio__inner::after {
  width: 8px;          /* default is ~8px */
  height: 8px;
  margin-top: -6px;     /* half of the height */
  margin-left: -6px;    /* half of the width */
}
/* now these will actually penetrate Element’s classes: */
.large-radio ::v-deep .el-radio__input {
  transform: scale(1.4);
  margin-right: 0.5rem;
}
</style>
